/**
 * WizardStepChild — Step 1: Informations de l'enfant.
 * Extracted from ContractWizard.jsx for maintainability.
 */
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const WizardStepChild = ({ data, onChange, children }) => (
  <div className="space-y-4">
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <Label>Prénom de l'enfant *</Label>
        <Input value={data.child_first_name} onChange={(e) => onChange({ ...data, child_first_name: e.target.value })} placeholder="Emma" required data-testid="wizard-child-first-name" />
      </div>
      <div>
        <Label>Nom de famille *</Label>
        <Input value={data.child_name} onChange={(e) => onChange({ ...data, child_name: e.target.value })} placeholder="Dupont" required data-testid="wizard-child-name" />
      </div>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <Label>Date de naissance *</Label>
        <Input type="date" value={data.child_birth_date} onChange={(e) => onChange({ ...data, child_birth_date: e.target.value })} required data-testid="wizard-child-birth-date" />
      </div>
      <div>
        <Label>Sexe</Label>
        <Select value={data.child_sex} onValueChange={(val) => onChange({ ...data, child_sex: val })}>
          <SelectTrigger data-testid="wizard-child-sex"><SelectValue placeholder="Sélectionner" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="M">Garçon</SelectItem>
            <SelectItem value="F">Fille</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
    {children}
  </div>
);
